module.exports = __webpack_public_path__ + "static/img/cf.cbd95957.svg";